
export default {
  data() {
    return {
      isScrolling: false,
      isBottom: false
    }
  },
  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      if (window.scrollY <= 200) {
        this.isScrolling = false
      } else {
        this.isScrolling = true
      }

      // Check if user has scrolled to bottom
      const scrollTop = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      if (scrollTop + windowHeight >= documentHeight - 100) {
        // @ts-ignore
        this.isBottom = true
      } else {
        // @ts-ignore
        this.isBottom = false
      }
    }
  }
}
